module.exports = __webpack_public_path__ + "img/first_logo.2c35da05.svg";